module.exports = __webpack_public_path__ + "static/img/event3.f7de92b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/my-irish-date/event3.png
// module id = Nbae
// module chunks = 0